import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import AvailableOn from '../AvailableOn/AvailableOn';
import './TermConditions.css';   // reuse the same policies-section styles

const ReturnRefund = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Kuku Namkeen | Return & Refund Policy</title>
                <meta
                    name="description"
                    content="Kuku Namkeen Return & Refund Policy — Information about order cancellations and refunds for outlet and national delivery orders."
                />
                <link rel="canonical" href="https://kukunamkeen.in/return-refund-policy" />
            </Helmet>

            {/* Page Header Banner */}
            <section className="term-header-title">
                <div className="max-w-6xl mx-auto px-4">
                    <h1>Return & Refund Policy</h1>
                </div>
            </section>
            <img
                src="/Image/border-bottom-title.png"
                className="w-full header-title-image"
                alt=""
            />

            {/* Policy Content */}
            <section className="policies-section">
                <div className="max-w-6xl mx-auto px-4 lg:px-8">

                    {/* Outlet Orders */}
                    <div className="block-margin">
                        <h3 className="heading-title">Outlet Orders</h3>
                        <ul>
                            <li>
                                Cancellation allowed within 60 seconds of placing order, with full refund.
                                <br />
                                - Refund will be processed back to source within 3-5 business days
                            </li>
                            <li className="mt-2 text-dark-gray">
                                No cancellation of order post 60 seconds of placing order
                            </li>
                        </ul>
                    </div>

                    {/* National Delivery Orders */}
                    <div className="block-margin">
                        <h3 className="heading-title">National Delivery Orders</h3>
                        <ul>
                            <li>
                                Cancellation allowed till order is dispatched from warehouse, with full refund.
                                <br />
                                - Refund will be processed back to source within 3-5 business days
                            </li>
                            <li className="mt-2 text-dark-gray">
                                No cancellation of order post order dispatch from warehouse
                            </li>
                            <li className="mt-2 text-dark-gray">
                                To initiate cancellation of National Delivery orders, please send a cancellation request email with order ID to -{' '}
                                <a href="mailto:kukunamkeen65@gmail.com" className="text-blue font-semibold hover:underline">
                                    kukunamkeen65@gmail.com
                                </a>
                            </li>
                        </ul>
                    </div>

                </div>
            </section>

            {/* Available On */}
            <AvailableOn />
        </>
    );
};

export default ReturnRefund;
